<template>
  <section class="amp__page-wrapper">
    <div class="amp t-container">
      <div class="amp__hero hero" v-animation:bottom.delay>
        <div class="hero__brand">
          <img class="hero__logo" src="/dist/img/ax-max-pro/logo_maximum_pro.svg" alt="Maximum PRO" />
          <div class="hero__text">
            <h1 class="hero__title visually-hidden">AXOFT MAXIMUM PRO</h1>
            <p class="hero__subtitle">Онлайн эфир крупнейшей конференции Axoft</p>
          </div>
        </div>

        <div class="hero__right">
          <img class="hero__sticker" src="/dist/img/ax-max-pro/sticker.svg" alt="AXOFT MAXIMUM PRO" aria-hidden="true" />
        </div>
      </div>

      <div class="amp__tabs tabs" v-animation:bottom.delay>
        <div class="tabs__list">
          <button
            v-for="(t, i) in tabs"
            :key="t.id"
            class="tabs__btn"
            :class="{ 'tabs__btn--active': activeTab === i }"
            @click="activeTab = i"
          >
            <img class="tabs__btn-img" :src="t.btnIcon" :alt="t.title" />
            {{ t.title }}
          </button>
          <a
            class="tabs__action-btn"
            :href="`${$root.__AXOFT__.axGlobalUrl}/questionnaires/testovyy_opros_po_meropriyatiyu_axoft_maximum_live`"
            target="_blank"
          >
            Пройти опрос
          </a>
        </div>
        <div v-animation:left class="amp-cube amp__cube--left" aria-label="Декор куб слева"></div>
      </div>

      <div class="amp__stage stage" v-animation:bottom.delay>
        <div class="stage__video">
          <div class="stage__select-broadcast select-broadcast">
            <p class="select-broadcast__title">Выбрать трансляцию</p>
            <dropdown-cmp class="select-broadcast__dropdown" v-model="activeTab" :options="tabs" :label-resolver="i => tabs[i].title">
              <template #option="{ value }">
                {{ value.title }}
              </template>
            </dropdown-cmp>
          </div>
          <video
            class="stage__video-el"
            controls
            playsinline
            preload="metadata"
            :poster="current.poster"
            :src="current.video"
            @play="pauseOthers"
            ref="mainVideo"
          ></video>

          <p class="stage__desc">{{ current.desc }}</p>

          <ul v-if="current.vandors && current.vandors.length > 0" class="amp__vendors amp-vendors" aria-label="Партнёры мероприятия">
            <li v-for="v in current.vandors" :key="v.src" class="amp-vendors__item">
              <a :href="v.href" target="_blank">
                <img class="amp-vendors__logo" :src="v.src" :alt="v.alt" />
              </a>
            </li>
          </ul>

          <a
            class="stage__cta amp__quiz-btn"
            :href="`${$root.__AXOFT__.axGlobalUrl}/questionnaires/testovyy_opros_po_meropriyatiyu_axoft_maximum_live`"
            target="_blank"
          >
            Пройти опрос
          </a>
          <p class="stage__hint">
            Пожалуйста, пройдите небольшой опрос, и получите сертификат участника крупнейшей IT-конференции Axoft Maximum PRO
          </p>
        </div>
        <div class="stage__chat">
          <div class="stage__chat-frame"></div>
          <div v-animation:right class="amp-cube amp__cube--right" aria-label="Декор куб справа"></div>
        </div>
      </div>
      <div class="amp__mobile-btn" v-animation:bottom>
        <a
          class="amp__quiz-btn amp__quiz-btn"
          :href="`${$root.__AXOFT__.axGlobalUrl}/questionnaires/testovyy_opros_po_meropriyatiyu_axoft_maximum_live`"
          target="_blank"
        >
          Пройти опрос
        </a>
      </div>
      <div class="amp__cards cards">
        <amp-info-cmp class="cards__item cards__item--info" v-animation:bottom></amp-info-cmp>
        <div class="amp__mobile-btn" v-animation:bottom>
          <a
            class="amp__quiz-btn amp__quiz-btn"
            :href="`${$root.__AXOFT__.axGlobalUrl}/questionnaires/testovyy_opros_po_meropriyatiyu_axoft_maximum_live`"
            target="_blank"
          >
            Пройти опрос
          </a>
        </div>
        <amp-rate-cmp class="cards__item cards__item--rate" v-animation:bottom></amp-rate-cmp>
      </div>
    </div>
  </section>
</template>

<script>
import MaxproRate from "./maxpro-rate.vue"
import MaxproInfo from "./maxpro-info.vue"
import Dropdown from "./maxpro-dropdown.vue"
import { ATTENDANCE_STORAGE_KEY } from "@pages/axoft-maximum-pro/consts/amp"
import { observeNewAnimateBlocks } from "@src/libs/animate/scroll.animate"

export default {
  name: "amp",
  components: {
    "amp-rate-cmp": MaxproRate,
    "amp-info-cmp": MaxproInfo,
    "dropdown-cmp": Dropdown,
  },
  props: {
    participantId: {
      type: String,
    },
  },
  data() {
    return {
      tabs: [
        {
          id: "t1",
          title: "Трансляция 1",
          btnIcon: "/dist/img/ax-max-pro/circle.png",
          video: "https://www.w3schools.com/html/mov_bbb.mp4",
          chat: "https://example.com",
          poster: "https://dummyimage.com/640x360/1e293b/ffffff&text=Stream+1",
          desc:
            "Деловая площадка для обсуждения ключевых вопросов IT-бизнеса и нетворкинга среди ведущих игроков России и стран Ближнего Зарубежья: интеграторов, реселлеров, вендоров и дистрибутора.",
          vandors: [
            { src: "/dist/img/ax-max-pro/vendor_kaspersky.png", href: "https://axoftglobal.ru/vendors/kaspersky", alt: "Касперский" },
            {
              src: "/dist/img/ax-max-pro/vendor_kod_bezopasnosti.png",
              href: "https://axoftglobal.ru/vendors/kod_bezopasnosti",
              alt: "Код безопасности",
            },
            { src: "/dist/img/ax-max-pro/vendor_solar.png", href: "https://axoftglobal.ru/vendors/solar", alt: "Солар" },
            {
              src: "/dist/img/ax-max-pro/vendor_positive_technologies.png",
              href: "https://axoftglobal.ru/vendors/positive_technologies",
              alt: "Позитив",
            },
            {
              src: "/dist/img/ax-max-pro/vendor_postgrespro.png",
              href: "https://axoftglobal.ru/vendors/postgres_pro",
              alt: "Постгрес",
            },
            { src: "/dist/img/ax-max-pro/vendor_usergate.png", href: "https://axoftglobal.ru/vendors/usergate", alt: "Юзергейт" },
          ],
        },
        {
          id: "t2",
          title: "Трансляция 2",
          btnIcon: "/dist/img/ax-max-pro/cube_illustration.png",
          video: "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
          chat: "https://example.com",
          poster: "https://dummyimage.com/640x360/0f172a/ffffff&text=Stream+2",
          desc:
            "Деловая площадка для обсуждения ключевых вопросов IT-бизнеса и нетворкинга среди ведущих игроков России и стран Ближнего Зарубежья: интеграторов, реселлеров, вендоров и дистрибутора.",
          vandors: [
            { src: "/dist/img/ax-max-pro/vendor_kaspersky.png", href: "https://axoftglobal.ru/vendors/kaspersky", alt: "Касперский" },
            {
              src: "/dist/img/ax-max-pro/vendor_kod_bezopasnosti.png",
              href: "https://axoftglobal.ru/vendors/kod_bezopasnosti",
              alt: "Код безопасности",
            },
            { src: "/dist/img/ax-max-pro/vendor_solar.png", href: "https://axoftglobal.ru/vendors/solar", alt: "Солар" },
            {
              src: "/dist/img/ax-max-pro/vendor_positive_technologies.png",
              href: "https://axoftglobal.ru/vendors/positive_technologies",
              alt: "Позитив",
            },
            {
              src: "/dist/img/ax-max-pro/vendor_postgrespro.png",
              href: "https://axoftglobal.ru/vendors/postgres_pro",
              alt: "Постгрес",
            },
            { src: "/dist/img/ax-max-pro/vendor_usergate.png", href: "https://axoftglobal.ru/vendors/usergate", alt: "Юзергейт" },
          ],
        },
        {
          id: "t3",
          title: "Алло, Axoft!",
          btnIcon: "/dist/img/ax-max-pro/allo_axoft.png",
          video: "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/river.mp4",
          chat: "https://example.com",
          poster: "https://dummyimage.com/640x360/111827/ffffff&text=Stream+3",
          desc:
            "Деловая площадка для обсуждения ключевых вопросов IT-бизнеса и нетворкинга среди ведущих игроков России и стран Ближнего Зарубежья: интеграторов, реселлеров, вендоров и дистрибутора.",
          vandors: [
            { src: "/dist/img/ax-max-pro/vendor_kaspersky.png", href: "https://axoftglobal.ru/vendors/kaspersky", alt: "Касперский" },
            {
              src: "/dist/img/ax-max-pro/vendor_kod_bezopasnosti.png",
              href: "https://axoftglobal.ru/vendors/kod_bezopasnosti",
              alt: "Код безопасности",
            },
            { src: "/dist/img/ax-max-pro/vendor_solar.png", href: "https://axoftglobal.ru/vendors/solar", alt: "Солар" },
            {
              src: "/dist/img/ax-max-pro/vendor_positive_technologies.png",
              href: "https://axoftglobal.ru/vendors/positive_technologies",
              alt: "Позитив",
            },
            {
              src: "/dist/img/ax-max-pro/vendor_postgrespro.png",
              href: "https://axoftglobal.ru/vendors/postgres_pro",
              alt: "Постгрес",
            },
            { src: "/dist/img/ax-max-pro/vendor_usergate.png", href: "https://axoftglobal.ru/vendors/usergate", alt: "Юзергейт" },
          ],
        },
      ],
      activeTab: 0,

      rating: 0,
      comment: "",
      sending: false,
      rateState: "ask", // ask | thanks
    }
  },
  created() {
    this.setAttendanceFlag()
  },
  mounted() {
    setTimeout(() => {
      observeNewAnimateBlocks()
    }, 1100)
  },
  computed: {
    current() {
      return this.tabs[this.activeTab]
    },
  },
  methods: {
    pauseOthers(e) {
      const current = e?.target
      const list = this.$el.querySelectorAll("video")
      list.forEach(v => {
        if (v !== current && !v.paused) v.pause()
      })
    },

    async setAttendanceFlag() {
      try {
        const userPresenceFlag = JSON.parse(localStorage.getItem(ATTENDANCE_STORAGE_KEY))

        if (!userPresenceFlag && __AXOFT__?.crmApiUrl) {
          await fetch(`${__AXOFT__.crmApiUrl}/Campaign/updateparticipant`, {
            method: "POST",
            body: JSON.stringify({ participantId: this.participantId, approval: true, attendance: true }),
          })
          localStorage.setItem(ATTENDANCE_STORAGE_KEY, JSON.stringify(true))
        }
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/sass/params"

$card: #ffffff
$ink: #0f172a
$accent: #1AB8C4
$border: #e5e7eb
$radius: 6px

.t-page_max-pro
  min-height: 100%
  background: $dark-blue
  overflow-x: hidden

@keyframes spin-cube
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.amp
  $row-gap: 42px

  position: relative
  color: $ink

  &__quiz-btn
    display: block
    padding: 22px 126px
    border: 0
    border-radius: 4px
    background: $accent
    color: #fff
    font-size: 25px
    font-weight: 600
    cursor: pointer
    transition: filter .15s ease
    &:hover
      filter: brightness(.95)

  &__hero
    margin: 0 auto

  &-cube
    position: absolute
    width: 197px
    height: 197px
    background-repeat: no-repeat
    background-size: cover
    z-index: 10

    &:hover
      animation-name: spin-cube
      animation-duration: 5000ms
      animation-iteration-count: infinite
      animation-timing-function: linear

  &__cube
    &--left
      top: 0
      left: -165px
      background-image: url("/dist/img/ax-max-pro/cube.png")

    &--right
      top: 25%
      left: calc(100% - 15px)
      background-image: url("/dist/img/ax-max-pro/cube_2.png")

    &__tabs
      margin-bottom: $row-gap
  &__tabs
    position: relative

  &__stage
    margin-top: 42px
    margin-bottom: $row-gap

  &__cards
    display: flex
    gap: 35px

  &__mobile-btn
    display: none

/* ===== HERO ===== */
.hero
  display: flex
  align-items: flex-end
  justify-content: space-between
  gap: 16px

  &__brand
    display: flex
    flex-direction: column
    gap: 58px
    margin-top: 25px
    margin-left: 25px
    flex-shrink: 1

  &__logo
    display: block
    width: 400px

  &__subtitle
    margin-bottom: 38px
    font-size: 26px
    font-weight: 600
    color: #FFFFFF

  &__right
    flex-basis: 45%
    flex-shrink: 1

  &__sticker
    width: 580px
    filter: drop-shadow(0 6px 16px rgba(0,0,0,.35))

/* ====== TABS ====== */
.tabs
  &__list
    display: grid
    grid-template-columns: repeat(4, 1fr)
    gap: 26px

  &__btn
    display: flex
    gap: 15px
    align-items: center
    background: $card
    color: $ink
    border: 2px solid transparent
    border-radius: $radius
    font-size: 18px
    font-weight: 600
    padding: 7.5px 14px
    cursor: pointer
    transition: transform .06s ease

    &--active
      border-color: #1AB8C440

    &:hover
      .tabs__btn-img
        transform: scale(1.1)

    &-img
      transition: transform .3s
      width: 80px

  &__action-btn
    padding: 19px 14px
    display: flex
    align-items: center
    justify-content: center
    border-radius: $radius
    border: 0
    background: $accent
    color: white
    font-size: 25px
    font-weight: 600
    cursor: pointer
    transition: filter .15s
    &:hover
      filter: brightness(.95)

/* ====== STAGE ====== */
.stage
  display: flex
  gap: 49px
  background: $card
  border-radius: $radius
  padding: 32px 45px 56px 40px

  &__video
    display: flex
    flex-direction: column

  &__video-el
    display: block
    width: 100%
    aspect-ratio: 16 / 9
    background: #000
    border-radius: $radius
    object-fit: cover

  &__cta
    margin: 26px auto 0

  &__desc
    margin-top: 37px
    font-size: 16px
    line-height: 1.5
    color: $shades-black

  &__hint
    display: block
    margin: 26px auto 0
    max-width: 444px
    font-size: 16px
    line-height: 1.5
    text-align: center
    color: $shades-black

  &__chat
    position: relative

  &__chat-frame
    width: 394px
    height: 818px
    background: #111827

/* ====== VENDORS GRID ====== */
.amp-vendors
  margin-top: 13px
  padding: 0
  list-style: none
  display: grid
  grid-template-columns: repeat(3, minmax(0, 1fr))
  gap: 30px
  align-items: center

  &__item
    display: grid
    place-items: center
    padding: 8px

  &__logo
    object-fit: contain
    filter: grayscale(10%)

.cards
  &__item
    background: $card
    border-radius: $radius
    padding: 32px 49px 32px 40px

    &--rate
      flex-basis: 454px
      align-self: flex-start

.select-broadcast
  display: none



/* ====== ADAPTIVE ====== */
@media (max-width: $desktop-medium)
  .stage__chat-frame
    width: 320px

@media (max-width: $tablet-header)
  .amp
    padding-block-start: 80px

@media (max-width: $tablet-size)
  .tabs__btn
    gap: 7px
    padding: 5px 5px
  .tabs__list
    gap: 15px
  .amp__stage
    margin-top: 25px
    margin-bottom: 25px
  .stage
    padding: 31px 16px
    gap: 25px
  .cards__item
    padding: 15px 16px 35px
  .amp__cards
    gap: 25px


@media (max-width: $mobile-size)
  .select-broadcast
    display: block

    &__title
      text-align: center
      font-size: 18px
      padding-bottom: 24px
      margin-bottom: 15px
      border-bottom: 1px solid #EFEFF0

    &__dropdown
      margin-bottom: 15px

  .t-page_max-pro
    padding-top: 90px

  .amp__mobile-btn
    display: flex
    justify-content: center
    padding: 38px 10px
    margin-inline: auto

  .amp-cube, .stage__chat, .hero__right, .tabs, .stage__desc, .amp__vendors, .stage__cta, .stage__hint
    display: none

  .amp
    padding-top: 84px

    &__quiz-btn
      font-size: 14px
      font-weight: 400
      padding: 16px 90px

    &__stage
      justify-content: center
      margin-top: unset
      margin-bottom: unset
      border-bottom-left-radius: 0
      border-bottom-right-radius: 0

    &__cards
      gap: unset
      flex-direction: column

  .cards__item
    &--info
      border-bottom-left-radius: 0
      border-bottom-right-radius: 0

    &--rate
      flex-basis: unset

  .hero
    justify-content: center

    &__brand
      padding-inline: 16px
      align-items: center
      margin-top: unset
      margin-left: unset
      gap: 12px
    &__logo
      width: 212px
    &__subtitle
      font-size: 18px
      margin-bottom: 31px
      width: 234px
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/amp.vue